const Config = {
  VERSION: process.env.REAC_APP_VERSION,
  NAME: process.env.REACT_APP_NAME,
  BACKEND_URL: process.env.REACT_APP_BACKEND_URL,
  CARRIER_CONFIG_URL: process.env.REACT_APP_CARRIER_CONFIG_URL,
  REBOOKING_DELIVERYVIEW_URL: process.env.REACT_APP_REBOOKING_DELIVERYVIEW_URL,
  REBOOKING_SERVICE_URL: process.env.REACT_APP_REBOOKING_SERVICE_URL,
  USER_PREFERENCES_URL: process.env.REACT_APP_USER_PREFERENCES_URL,
  BASEPATH: process.env.REACT_APP_BASEPATH,
  BASEPATH_USER_PREFERENCES_CONFIG: process.env.REACT_APP_BASEPATH_USER_PREFERENCES_CONFIG,
  OKTA_ISSUER: process.env.REACT_APP_OKTA_ISSUER,
  ENV: process.env.REACT_APP_ENV,
  MAP_ADDRESSLINE_3_TO_PUP_IDENTIFIER:
    process.env.REACT_APP_MAP_ADDRESSLINE_3_TO_PUP_IDENTIFIER === 'true',
}

export default Config
